import { markRaw } from 'vue'
import eTitle from './eTitle'
import headline from './headline'
import eText from './eText'
import eImage from './eImage'
import eResource from './eResource'
import eTable from './eTable'
import eSubmit from './eSubmit'
import eFormula from './eFormula'
import eSketchpad from './eSketchpad'
import eInteract from './eInteract'
import eMindmap from './eMindmap'
import eExercise from './eExercise'

export default {
  title: markRaw(eTitle),
  H1: markRaw(headline),
  H2: markRaw(headline),
  H3: markRaw(headline),
  H4: markRaw(headline),
  H5: markRaw(headline),
  text: markRaw(eText),
  image: markRaw(eImage),
  resource: markRaw(eResource),
  table: markRaw(eTable),
  submit: markRaw(eSubmit),
  mathematical: markRaw(eFormula),
  sketchpad: markRaw(eSketchpad),
  interactiveTools: markRaw(eInteract),
  mindMap: markRaw(eMindmap),
  exercise: markRaw(eExercise),
}
